import * as React from 'react';
import { SocialRow } from './SocialRow';
import { useSocialMedia } from '../../hooks/useSocialMedia';
import clsx from 'clsx';
import type { EchoDraftResponse } from '@/types/echo_creation';

interface SocialSectionProps {
  draftId: string;
  draft: EchoDraftResponse | null;
}

export const SocialSection: React.FC<SocialSectionProps> = ({ draftId, draft }) => {
  const { platforms, handleConnect, handleDisconnect, isUpdating } = useSocialMedia({
    draftId,
    draft,
  });

  return (
    <div className={clsx('w-full', isUpdating && 'pointer-events-none opacity-70')}>
      <p className='mb-6 font-sans text-16 font-medium leading-27 text-dark-300'>
        Link your social account to make your digital echo more like you.
      </p>

      <div
        className={clsx(
          'flex w-full flex-col',
          // Mobile/Standard Desktop: Constrained to 600px single column
          'max-w-screen-fold',
          // Large Screens (> 1440px): Full width, 2 Columns, Grid gap
          'wide:grid wide:max-w-full wide:grid-cols-2 wide:gap-x-6 wide:gap-y-4'
        )}
      >
        {platforms.map((platform) => (
          <SocialRow
            key={platform.id}
            platform={platform}
            onConnect={handleConnect}
            onDisconnect={handleDisconnect}
          />
        ))}
      </div>
    </div>
  );
};
